import { useDeviceInfo } from './useDeviceInfo';
import { useTouchDevice } from './useTouchDevice';

export const useMobileOrTouchDevice = () => {
  const isTouchDevice = useTouchDevice();
  const isMobileDevice = useDeviceInfo().deviceType === 'mobile';

  return isMobileDevice || isTouchDevice;
};
